export default __webpack_public_path__ + "images/vk.svg?433257d4a4182f7587a12d4b8fe62999";